import axios from '@/shared/axios';
import { BaseResponse } from '@/types/web.interface';

// 用户名检测
export async function postUsernameMonitorApi(params: any) {
  const res = await axios.post<BaseResponse<any>>('/riskReport/usernameMonitor', params);
  return res.data;
}

// 用户名获取数据
export async function getReportUsernameDataApi(id: string) {
  const res = await axios.get<BaseResponse<any>>(`/riskReport/report/detail/${id}`);
  return res.data;
}

// 视频检测
export async function postVideoMonitorApi(params: any) {
  const res = await axios.post<BaseResponse<any>>('/riskReport/videoMonitor', params);
  return res.data;
}

// 图片检测
export async function postPhotoMonitorApi(params: any) {
  const res = await axios.post<BaseResponse<any>>('/riskReport/photoMonitor', params);
  return res.data;
}
